import { HOOK_ML_ASSET__get_by_hash } from '@/utils/HOOK_ML_ASSET__get_by_hash';
import { assert_string_hash_sha256 } from '@shared/asserts/utils_asserts';

interface PROPS {
  hash: string;
}

export function HOOK__ml_asset_name_and_version({ hash }: PROPS) {
  assert_string_hash_sha256(hash);

  const ml_asset_dto = HOOK_ML_ASSET__get_by_hash(hash);

  /*
   * METHODS
   */

  function get_display_name() {
    return ml_asset_dto.is_stub() ? hash : ml_asset_dto.name;
  }

  function get_display_version() {
    return ml_asset_dto.is_stub() ? '' : ml_asset_dto.version;
  }

  /*
   * RESULT
   */

  return {
    name: get_display_name(),
    version: get_display_version(),
  };
}
